export default __webpack_public_path__ + "static/media/Icon_ORSO.1209bf3c.svg";